<template>
  <div ref="container" class='container'>
    <loading
        :active.sync="vueLoadingIsLoading"
        :can-cancel="vueLoadingCanCancel"
        :is-full-page="vueLoadingFullPage"
        :loader="vueLoadingLoader"
        :opacity="vueLoadingOpacity"
        :background-color="vueLoadingBg"
        :height="vueLoadingHeight"
        :width="vueLoadingWidth">
    </loading>
  </div>
</template>

<script>
// import echarts from 'echarts'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/line')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/toolbox')
require('echarts/lib/component/timeline')
require('echarts/lib/component/markPoint')
require('echarts/lib/component/markLine')

export default {
  name: 'Home',
  components: {
    loading: Loading
  },
  data () {
    return {
      // CopListDict: '',
      RealDateRange: '',
      AllData: '',
      // AllDataTop5: {},
      CopListDict: {},
      PercentListDictUp: {},
      PercentListDictDown: {},
      legendSelected: '市值榜',
      percentDataUp: {},
      percentDataDown: {},
      myEcharts: '',
      vueLoadingIsLoading: false,
      RemindIsRemiding: false,
      vueLoadingCanCancel: false,
      vueLoadingFullPage: false,
      vueLoadingLoader: 'bars',
      vueLoadingOpacity: 0.2,
      vueLoadingBg: '#725353',
      vueLoadingHeight: 128,
      vueLoadingWidth: 128
    }
  },
  created () {
    this.axios.interceptors.request.use((config) => {
      // trigger 'loading=true' event here
      this.upside()
      return config
    }, (error) => {
      // trigger 'loading=false' event here
      this.upside()
      return Promise.reject(error)
    })

    this.axios.interceptors.response.use((response) => {
      // trigger 'loading=false' event here
      this.upside()
      return response
    }, (error) => {
      // trigger 'loading=false' event here
      this.upside()
      return Promise.reject(error)
    })
  },
  mounted () {
    // console.log('mounted')
    this.fetchData()
    // this.myEcharts.on('legendselectchanged', function (params) {
    //   console.log(params.name)
    //   console.log(params.selected)
    // }
    // )
  },
  updated () {
    // console.log('updated')
    // this.renderEcharts(this.myEcharts, this.CopListDict, this.RealDateRange, this.AllData)
  },
  computed: {
    deviceParams: function () {
      let params = {}
      if (window.innerWidth <= 500) {
        params = {
          legendx: '5%',
          legendy: '7%',
          toolboxright: '3%',
          gridtop: 110,
          gridbottom: 80,
          gridleft: '3%',
          gridright: '12%'
        }
      } else {
        params = {
          legendx: '50%',
          legendy: '',
          toolboxright: '5%',
          gridtop: 60,
          gridbottom: 80,
          gridleft: '6%',
          gridright: '10%'
        }
      }
      return params
    }
  },
  methods: {
    upside: function () {
      this.vueLoadingIsLoading = !this.vueLoadingIsLoading
    },
    fetchData: function () {
      this.axios({
        method: 'get',
        url: 'https://v2.stockhey.com/static/file/allrank.json'
      })
        .then(response => {
          var data = response.data
          // this.CopListDict = data['CopList_dict']
          this.RealDateRange = data['real_date_range']
          this.percentDataUp = data['percent_data_up']
          this.percentDataDown = data['percent_data_down']
          this.AllData = data['stock_value_data']
          for (var indexx in data['stock_value_data']) {
            // console.log(indexx)
            this.CopListDict[indexx] = []
            for (var xxx in data['stock_value_data'][indexx]) {
              this.CopListDict[indexx].push(data['stock_value_data'][indexx][xxx]['name'])
            }
          }
          // get PercentListDictUp
          for (var indeyy in data['percent_data_up']) {
            this.PercentListDictUp[indeyy] = []
            for (var xxxx in data['percent_data_up'][indeyy]) {
              this.PercentListDictUp[indeyy].push(data['percent_data_up'][indeyy][xxxx]['name'])
            }
          }

          // get PercentListDictDown
          for (var indezz in data['percent_data_down']) {
            this.PercentListDictDown[indezz] = []
            for (var xxxxx in data['percent_data_down'][indezz]) {
              this.PercentListDictDown[indezz].push(data['percent_data_down'][indezz][xxxxx]['name'])
            }
          }
          this.echartsInit()
          this.renderEcharts(this.myEcharts, this.CopListDict, this.PercentListDictUp, this.PercentListDictDown, this.RealDateRange, this.AllData, this.percentDataUp, this.percentDataDown, this.legendSelected, this.deviceParams)
        })
        .catch(error => {
          console.log(error)
        })
    },
    echartsInit: function () {
      var self = this
      if (!this.$refs.container) {
        return
      } else {
        var dom = this.$refs.container
      };
      this.myEcharts = echarts.init(dom)
      this.myEcharts.on('legendselectchanged', function (params) {
        // console.log(params.name)
        if (self.legendSelected !== params.name) {
          self.legendSelected = params.name
          self.renderEcharts(self.myEcharts, self.CopListDict, self.PercentListDictUp, self.PercentListDictDown, self.RealDateRange, self.AllData, self.percentDataUp, self.percentDataDown, self.legendSelected, self.deviceParams)
          // console.log(self.option.baseOption.legend)
        }
      })
    },
    renderEcharts: function (xcharts, CopListDict, PercentListDictUp, PercentListDictDown, RealDateRange, AllData, percentDataUp, percentDataDown, legendSelected, deviceParams) {
      xcharts.showLoading({
        text: '正在加载数据'
      })
      var option = null
      function GetOptions () {
        var MyOptionsValue = []
        var MyOptionsPercentUp = []
        var MyOptionsPercentDown = []
        for (var i = 0; i < RealDateRange.length; i++) {
          var date = RealDateRange[i]
          MyOptionsValue.push(
            {
              title: {
                text: date + '日(中美沙)上市公司市值30强(亿/￥)',
                textStyle: {
                  color: '#D53A35'
                }
              },
              legend: {
                selected: {
                  '市值榜': true,
                  '涨幅榜': false,
                  '跌幅榜': false
                }
              },
              series: [{
                data: AllData[date],
                name: '市值榜',
                z: 0,
                type: 'bar',
                label: {
                  show: true,
                  position: 'right',
                  color: '#293B55',
                  fontWeight: 'bold',
                  distance: 1,
                  fontSize: 14,
                  shadowBlur: 3,
                  formatter: function (params) {
                    return params.name // .replace('\n', '');
                  }
                },
                markLine: {
                  silent: false,
                  itemStyle: {
                    normal: {
                      lineStyle: {
                        type: 'dotted', // 'solid',
                        //  这儿设置的颜色是公共配置，如需单独配置，请在data里配置
                        color: '#293B55'
                      },
                      label: {
                        show: true,
                        position: 'start'
                      }
                    }
                  },
                  data: [{
                    xAxis: 5000
                  }, {
                    xAxis: 15000
                  }, {
                    xAxis: 30000
                  }, {
                    xAxis: 40000
                  }, {
                    xAxis: 80000
                  }, {
                    xAxis: 100000
                  }, {
                    xAxis: 120000
                  }]
                } }],
              xAxis: [
                {
                  type: 'value',
                  name: '市值(亿/￥)'
                }],
              yAxis: [
                {
                  type: 'category',
                  show: false,
                  inverse: true,
                  // axisLabel: { 'interval': 0, 'rotate': 0 }, // rotate:  -50
                  data: CopListDict[date],
                  splitLine: { 'show': false }
                }
              ] }
          )
          MyOptionsPercentUp.push(
            {
              title: {
                text: date + '日(中美)上市公司市值涨幅30强(%)',
                textStyle: {
                  color: '#D53A35'
                }
              },
              legend: {
                selected: {
                  '市值榜': false,
                  '涨幅榜': true,
                  '跌幅榜': false
                }
              },
              series: [{
                data: percentDataUp[date],
                name: '涨幅榜',
                type: 'bar',
                z: 0,
                label: {
                  show: true,
                  position: 'right',
                  color: '#293B55',
                  fontWeight: 'bold',
                  distance: 1,
                  fontSize: 14,
                  shadowBlur: 3,
                  formatter: function (params) {
                    return params.name // .replace('\n', '');
                  }
                },
                markLine: {
                  silent: false,
                  itemStyle: {
                    normal: {
                      lineStyle: {
                        type: 'dotted', // 'solid',
                        //  这儿设置的颜色是公共配置，如需单独配置，请在data里配置
                        color: '#293B55'
                      },
                      label: {
                        show: true,
                        position: 'end'
                      }
                    }
                  },
                  data: [{
                    xAxis: 5
                  }, {
                    xAxis: 10
                  }, {
                    xAxis: 20
                  }, {
                    xAxis: 50
                  }, {
                    xAxis: 100
                  }, {
                    xAxis: 150
                  }, {
                    xAxis: 200
                  }]
                } }],
              xAxis: [
                {
                  type: 'value',
                  name: '市值涨幅(%)'
                }
              ],
              yAxis: [
                {
                  show: false,
                  type: 'category',
                  axisLabel: { 'interval': 0, 'rotate': -50 },
                  data: PercentListDictUp[date],
                  splitLine: { 'show': false }
                }

              ] }
          )
          MyOptionsPercentDown.push(
            {
              title: {
                text: date + '日(中美)上市公司市值跌幅30强(%)',
                textStyle: {
                  color: 'green'
                }
              },
              legend: {
                selected: {
                  '市值榜': false,
                  '涨幅榜': false,
                  '跌幅榜': true
                }
              },
              color: 'green',
              series: [{
                name: '跌幅榜',
                z: 0,
                type: 'bar',
                label: {
                  show: true,
                  position: 'right',
                  color: '#293B55',
                  fontWeight: 'bold',
                  distance: 1,
                  fontSize: 14,
                  shadowBlur: 3,
                  formatter: function (params) {
                    return params.name // .replace('\n', '');
                  }
                },
                markLine: {
                  silent: false,
                  itemStyle: {
                    normal: {
                      lineStyle: {
                        type: 'dotted', // 'solid',
                        //  这儿设置的颜色是公共配置，如需单独配置，请在data里配置
                        color: '#293B55'
                      },
                      label: {
                        show: true,
                        position: 'end'
                      }
                    }
                  },
                  data: [{
                    xAxis: -2
                  }, {
                    xAxis: -5
                  }, {
                    xAxis: -8
                  }, {
                    xAxis: -10
                  }, {
                    xAxis: -15
                  }, {
                    xAxis: -20
                  }, {
                    xAxis: -30
                  }, {
                    xAxis: -40
                  }, {
                    xAxis: -50
                  }]
                },
                data: percentDataDown[date]
              }],
              xAxis: [
                {
                  type: 'value',
                  name: '市值跌幅(%)',
                  nameLocation: 'start',
                  inverse: true
                }
              ],
              yAxis: [
                {
                  show: false,
                  type: 'category',
                  axisLabel: { 'interval': 0, 'rotate': -50 },
                  data: PercentListDictDown[date],
                  splitLine: { 'show': false }
                }

              ] }
          )
        }
        if (legendSelected === '市值榜') {
          return (MyOptionsValue)
        } else if (legendSelected === '涨幅榜') {
          return (MyOptionsPercentUp)
        } else {
          return (MyOptionsPercentDown)
        }
      }

      option = {
        baseOption: {
          timeline: {
            //  y: 0,
            axisType: 'category',
            //  realtime: false,
            //  loop: false,
            autoPlay: true,
            //  currentIndex: 2,
            playInterval: 5000,
            left: '0%',
            right: '0%',
            // controlStyle: {
            //      position: 'bottom'
            //  },
            data: RealDateRange,
            label: {
              formatter: function (s) {
                return (s) // (new Date(s)).getFullYear();
              }
            }
          },
          title: {
            subtext: '数据来自互联网',
            left: '5%'
          },
          tooltip: {
          },
          toolbox: {
            show: true,
            orient: 'vertical',
            right: deviceParams.toolboxright,
            top: '25%',
            z: 2,
            feature: {
              dataView: { readOnly: false },
              magicType: { type: ['bar', 'line'] },
              restore: {},
              saveAsImage: {}
            }
          },
          color: ['#D53A35', '#D53A35', 'green'],
          legend: {
            x: deviceParams.legendx,
            y: deviceParams.legendy,
            data: ['市值榜', '涨幅榜', '跌幅榜'],
            itemWidth: 35,
            itemHeight: 25,
            textStyle: {
              fontSize: 16
            },
            selectedMode: 'single',
            selected: {
              // '市值榜': this.szb,
              // '涨幅榜': this.zfb,
              // '跌幅榜': this.dfb
            }
          },
          calculable: true,
          grid: {
            top: deviceParams.gridtop,
            bottom: deviceParams.gridbottom,
            left: deviceParams.gridleft,
            right: deviceParams.gridright,
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow',
                label: {
                  show: true,
                  formatter: function (params) {
                    return params.value // .replace('\n', '');
                  }
                }
              }
            }
          },
          xAxis: [
            {
            }
          ],
          yAxis: [
            {
            }
          ],
          series: [
            {
              name: '市值榜',
              type: 'bar'
            },
            {
              name: '涨幅榜',
              type: 'bar'
            },
            {
              name: '跌幅榜',
              type: 'bar'
            }
          ]
        },
        options: GetOptions()
      }
      // console.log(option)
      if (option && typeof option === 'object') {
        xcharts.hideLoading()
        xcharts.setOption(option, true)
      }
    }
  }
}
</script>

<style scoped>
  div.container {
  min-height:700px;
  margin-top: 10px;
  padding-left:0%;
  padding-right:0%;
  position: relative;
  z-index: 0
}

@media (min-width: 500px){
div.container {
  padding-left:10%;
  padding-right:10%;
}}
</style>
